import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header} from "./components/Default";
import { SidebarLeft } from "./components/Default";
import { Footer } from "./components/Default/Footer";
import { ToasterComponent } from "./components/Default/ToasterComponent";
import { useAuthContext } from "./context/Auth/Create";
import { Routers } from "./Routes/Routers";
function App() {
  const userAuth=useAuthContext();
  const location=useLocation();
  const routeName=location.pathname;
  if(routeName==="/login"){
    window.$("html").addClass("loginbackground");
  }
  else{
    window.$("html").removeClass("loginbackground");
  }
  useEffect(()=>{
    document.title=`Colgate - ${routeName.substring(1,routeName.length)}`;
    window.$(".app").removeClass("app-sidebar-mobile-toggled")
  },[routeName])
  return (
    <>
    {(userAuth.isAuthenticated && routeName !=="/live-occupancy" && !routeName.startsWith("/attendance-page-with-camera"))   && 
    <>
    <Header/> 
    <SidebarLeft/>
    </>
    }
  
      {/* <Header/>  */}
    {/* <SidebarLeft/>  */}
    <Routers/>
    <ToasterComponent />
    {routeName !=="/live-occupancy" && <Footer/>}
   </>   
  );
}

export default App;
